// One figure: a slider to sweep it and a box to type it exactly. Both hold the same string; a
// percentage is shown and typed as one but held as the fraction the API takes.
//
// The box keeps what is being typed as a draft and passes it on only once it reads as a number, so
// "0." or "-" on the way to "0.5" or "-1" is not sent - or thrown away - half-typed. A field with no
// value shows an empty box, marked; clearing the box empties the field.

import { useId, useState } from 'react';

import { fromPercent, toPercent } from './inputs.js';

const NUMBER = /^-?\d+(\.\d+)?$/;

export default function SliderField({ label, value, range, onChange }) {
  const id = useId();
  const [draft, setDraft] = useState(null);
  const scale = range.percent ? 100 : 1;
  const empty = value == null;
  const shown = empty ? '' : range.percent ? toPercent(value) : String(value);
  const current = Number(shown) || 0;
  // A value beyond the range stretches it: the slider never moves a figure it was not asked to.
  const min = Math.min(range.min * scale, current);
  const max = Math.max(range.max * scale, current);

  const set = (text) => onChange(range.percent ? fromPercent(text) : text);

  const onType = (event) => {
    const text = event.target.value.trim();
    setDraft(text);
    if (text === '') onChange(null);
    else if (NUMBER.test(text)) set(text);
  };

  return (
    <div className={empty ? 'econ-slider is-empty' : 'econ-slider'}>
      <label htmlFor={id}>{label}</label>
      <input type="range" min={min} max={max} step={range.step * scale} value={current}
             onChange={(event) => set(event.target.value)} aria-label={label} />
      <span className="econ-slider-box">
        <input id={id} type="text" inputMode="decimal" value={draft ?? shown}
               onChange={onType} onBlur={() => setDraft(null)} />
        <span className="econ-unit">{range.percent ? '%' : range.unit}</span>
      </span>
    </div>
  );
}
